<template>
  <div>
    <vs-popup title="پلن همیار فروش" :active.sync="showModal">
      <div class="vx-row">
        <div class="vx-col w-full mb-base">
          <data-grid
            ref="grid"
            stripe
            :data-source="gridDataSource"
            :columns="[
              { title: $t('Name'), sort: 'Name' },
              { title: $t('Action') },
            ]"
          >
            <template slot-scope="{ row }">
              <td style="width: 65%">
                {{ row.name }}
              </td>

              <td style="width: 25%">
                <vs-button
                  color="primary"
                  type="border"
                  icon-pack="feather"
                  class="bordered-btn"
                  @click.prevent="selectPlan(row)"
                  >انتخاب</vs-button
                >
              </td>
            </template>
          </data-grid>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import vSelect from "vue-select";
import DataGrid from "@/components/datagrid/DataGrid";

export default {
  props: {
    show: { default: false },
    promoterId: "",
  },
  components: {
    DataGrid,
    "v-select": vSelect,
  },
  data() {
    return {
      gridDataSource: {
        type: "app",
        service: "Promotion/api/PromoterPlan",
      },
      disabled: true,
      model: {},
      showError: true,
      planRelatedPromoter: "",
    };
  },
  computed: {
    showModal: {
      get: function () {
        return this.show;
      },
      set: function () {
        this.$emit("close");
      },
    },
  },
  methods: {
    ...mapActions({
      assignPlan: "SalesPartnerPlan/assignPlan",
    }),
    selectPlan(plan) {
      this.model.promoterPlanId = plan.id;
      this.model.promoterId = this.promoterId;

      this.assignPlan(this.model).then(() => {
        this.planRelatedPromoter = plan.name;
        this.$emit("finish");
      });
    },
  },
  watch: {},
};
</script>
